/* istanbul ignore file */

import { connect } from 'react-redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectPersonalisationOptionsBreakdown,
  selectSelectedPersonalisationsTotal,
  selectTotalPrice,
} from 'src/redux/personalisation/selectors';
import { selectProduct, selectProductPrice } from 'src/redux/selectors';
import type { PriceBreakdownStateProps } from './PriceBreakdown';
import { PriceBreakdown } from './PriceBreakdown';

export const mapStateToProps = (state: ReduxApplicationState): PriceBreakdownStateProps => {
  const product = selectProduct(state);

  return {
    personalisable: product.specialFeatures.personalisable,
    productPrice: selectProductPrice(state),
    totalPrice: selectTotalPrice(state),
    optionsTotal: selectSelectedPersonalisationsTotal(state),
    priceBreakdown: selectPersonalisationOptionsBreakdown(state),
  };
};

export const PriceBreakdownContainer = connect(mapStateToProps)(PriceBreakdown);
